import axios from 'axios';
import { GET_RECU_REQS, GET_SPECIFIC_RECU_REQ, ADD_RECU_REQ, EDIT_RECU_REQ, ANSWER_RECU_REQ, DELETE_RECU_REQ, CLEAR_RECU_REQS, RECU_REQS_LOADING } from '../types';
import { tokenConfig } from './authActions';
import { returnErrors } from './errorActions';
import store from '../store';

export const getRecuReqs = () => (dispatch: Function, getState: Function) => {
  dispatch({
    type: RECU_REQS_LOADING
  });
  axios
    .get('/api/recureqs', {...tokenConfig(getState), params: {}})
    .then(res =>
      dispatch({
        type: GET_RECU_REQS,
        payload: res.data
      })
    )
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
    });
};

export const addRecuReq = (vcIds: number[], veIds: number[], venteId: number, partId: number, isPart: number, isSupp: number, prevRecuId: number, callback: Function) => (
  dispatch: Function,
  getState: Function
) => {
  axios
    .post('/api/recureqs', {vcIds, veIds, venteId, partId, isPart, isSupp, prevRecuId}, tokenConfig(getState))
    .then(res => {
      dispatch({
        type: ADD_RECU_REQ,
        payload: res.data
      });
      callback(res.data)
    })
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
      callback(err?.response ? {err: err.response.data} : false)
    });
};

export const answerRecuReq = (id: number, approved: number, comment: string, upload: any, callback: Function) => (
  dispatch: Function,
  getState: Function
) => {
  axios
    .post('/api/recureqs/answer', {id, approved, comment, upload}, tokenConfig(getState))
    .then(res => {
      if(approved === 1)
        dispatch({
          type: ANSWER_RECU_REQ,
          payload: res.data
        });
      else
        dispatch({
          type: DELETE_RECU_REQ,
          payload: id
        });
      callback(res.data, approved)
    })
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
      callback(false)
    });
};

export const deleteRecuReq = (id: number, callback: Function) => (
  dispatch: Function,
  getState: Function
) => {
  axios
    .delete(`/api/recureqs/${id}`, tokenConfig(getState))
    .then(res => {
      dispatch({
        type: DELETE_RECU_REQ,
        payload: id
      })
      callback(true)
    })
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
      callback(false)
    });
};

export const clearRecuReqs = () => (
  dispatch: Function,
  getState: Function
) => {
  dispatch({
    type: CLEAR_RECU_REQS
  })
};